// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogVariant from "../../modules/Catalog/CatalogVariant.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogVariantEditUrlState from "../../modules/Catalog/CatalogVariantEditUrlState.res.js";
import * as CatalogVariantEdit__Queries from "./CatalogVariantEdit__Queries.res.js";

let CatalogVariantEdit_VariantNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEdit__Config.CatalogVariantEdit_VariantNotFound");

let CatalogVariantEdit_VariantProductNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEdit__Config.CatalogVariantEdit_VariantProductNotFound");

let CatalogVariantEdit_ProductNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEdit__Config.CatalogVariantEdit_ProductNotFound");

function makeVariantFilterBy(activeShopId) {
  return CatalogVariantEdit__Queries.VariantQuery.makeInputObjectInputVariantsByCkuQueryFilter(activeShopId !== undefined ? CatalogVariantEdit__Queries.VariantQuery.makeInputObjectInFilter([activeShopId], undefined) : undefined, undefined, "INCLUDED", undefined);
}

function makeProductFilterBy(activeShopId) {
  return CatalogVariantEdit__Queries.ProductQuery.makeInputObjectInputProductsByVariantCkuQueryFilter(activeShopId !== undefined ? CatalogVariantEdit__Queries.ProductQuery.makeInputObjectInFilter([activeShopId], undefined) : undefined, "INCLUDED", undefined);
}

function variantFromData(data) {
  let match = data.variantsByCku.edges[0];
  if (match !== undefined) {
    return match.node;
  }
  throw {
    RE_EXN_ID: CatalogVariantEdit_VariantNotFound,
    Error: new Error()
  };
}

function variantProductFromData(data) {
  let product = Stdlib_Option.map(data.variantsByCku.edges[0], param => param.node.product);
  if (product !== undefined) {
    return product;
  }
  throw {
    RE_EXN_ID: CatalogVariantEdit_VariantProductNotFound,
    Error: new Error()
  };
}

function productFromData(data) {
  let match = data.productsByVariantCku.edges[0];
  if (match !== undefined) {
    return match.node;
  }
  throw {
    RE_EXN_ID: CatalogVariantEdit_ProductNotFound,
    Error: new Error()
  };
}

function use(variantResponse, productResponse) {
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let productValues = CatalogVariantEditUrlState.CreateVariantFromProduct.decode(Navigation.useUrl().state);
  if (shops.length === 0) {
    return "Loading";
  }
  let exit = 0;
  let exit$1 = 0;
  if (variantResponse.TAG === "Executed") {
    if (variantResponse._0.loading) {
      return "Loading";
    }
    exit$1 = 3;
  } else if (productResponse.TAG === "Executed") {
    exit$1 = 3;
  } else {
    if (productValues === undefined) {
      return "Error";
    }
    if (productValues.TAG !== "Ok") {
      return "Error";
    }
    if (activeShop === undefined) {
      return "Error";
    }
    let product = productValues._0;
    return {
      TAG: "Data",
      _0: {
        id: "",
        productKind: product.kind,
        productTaxRate: Stdlib_Option.map(product.tax, param => param.value),
        productValues: product,
        initialValues: {
          name: "",
          capacityUnit: CatalogVariant.CapacityUnit.getDefaultFromProductKind(product.kind),
          capacityValue: undefined,
          capacityPrecision: undefined,
          ean13: "",
          stockKeepingUnit: "",
          stockKeepingUnitIsDuplicate: false,
          priceLookUpCode: {
            invalidValues: [],
            value: undefined
          },
          internalCode: "",
          alcoholVolume: undefined,
          year: undefined,
          bulk: false,
          purchasePrice: undefined,
          supplierId: "",
          variantPrices: [],
          initialStockQuantity: undefined,
          initialStockComment: "",
          maxStockThreshold: undefined,
          minStockThreshold: undefined,
          stockOrderTriggerThreshold: undefined
        },
        formattedName: product.name,
        shopName: activeShop.name
      }
    };
  }
  if (exit$1 === 3) {
    if (productResponse.TAG === "Executed") {
      if (productResponse._0.loading) {
        return "Loading";
      }
      exit = 2;
    } else {
      exit = 2;
    }
  }
  if (exit === 2 && variantResponse.TAG === "Executed") {
    let data = variantResponse._0.data;
    if (data !== undefined) {
      if (activeShop === undefined) {
        return "Error";
      }
      let variant = variantFromData(data);
      let product$1 = variantProductFromData(data);
      return {
        TAG: "Data",
        _0: {
          id: variant.id,
          productKind: product$1.kind,
          productTaxRate: undefined,
          productValues: undefined,
          initialValues: {
            name: variant.name,
            capacityUnit: variant.capacityUnit,
            capacityValue: variant.capacityValue,
            capacityPrecision: variant.capacityPrecision,
            ean13: Stdlib_Option.getOr(variant.ean13, ""),
            stockKeepingUnit: Stdlib_Option.getOr(variant.stockKeepingUnit, ""),
            stockKeepingUnitIsDuplicate: false,
            priceLookUpCode: {
              invalidValues: [],
              value: variant.priceLookUpCode
            },
            internalCode: Stdlib_Option.getOr(variant.internalCode, ""),
            alcoholVolume: variant.alcoholVolume,
            year: Stdlib_Option.map(variant.year, prim => prim),
            bulk: Stdlib_Option.getOr(variant.bulk, false),
            purchasePrice: variant.purchasedPrice,
            supplierId: "",
            variantPrices: undefined,
            initialStockQuantity: undefined,
            initialStockComment: "",
            maxStockThreshold: Stdlib_Option.map(variant.maxStockThreshold, prim => prim),
            minStockThreshold: Stdlib_Option.map(variant.minStockThreshold, prim => prim),
            stockOrderTriggerThreshold: Stdlib_Option.map(variant.stockOrderTriggerThreshold, prim => prim)
          },
          formattedName: variant.formattedName,
          shopName: activeShop.name
        }
      };
    }
  }
  if (productResponse.TAG !== "Executed") {
    return "Error";
  }
  let data$1 = productResponse._0.data;
  if (data$1 === undefined) {
    return "Error";
  }
  if (activeShop === undefined) {
    return "Error";
  }
  let product$2 = productFromData(data$1);
  return {
    TAG: "Data",
    _0: {
      id: product$2.id,
      productKind: product$2.kind,
      productTaxRate: product$2.tax.value,
      productValues: undefined,
      initialValues: {
        name: "",
        capacityUnit: CatalogVariant.CapacityUnit.getDefaultFromProductKind(product$2.kind),
        capacityValue: undefined,
        capacityPrecision: undefined,
        ean13: "",
        stockKeepingUnit: "",
        stockKeepingUnitIsDuplicate: false,
        priceLookUpCode: {
          invalidValues: [],
          value: undefined
        },
        internalCode: "",
        alcoholVolume: undefined,
        year: undefined,
        bulk: false,
        purchasePrice: undefined,
        supplierId: "",
        variantPrices: [],
        initialStockQuantity: undefined,
        initialStockComment: "",
        maxStockThreshold: undefined,
        minStockThreshold: undefined,
        stockOrderTriggerThreshold: undefined
      },
      formattedName: product$2.name,
      shopName: activeShop.name
    }
  };
}

let VariantQuery;

let ProductQuery;

export {
  VariantQuery,
  ProductQuery,
  CatalogVariantEdit_VariantNotFound,
  CatalogVariantEdit_VariantProductNotFound,
  CatalogVariantEdit_ProductNotFound,
  makeVariantFilterBy,
  makeProductFilterBy,
  variantFromData,
  variantProductFromData,
  productFromData,
  use,
}
/* Auth Not a pure module */
